import { render, staticRenderFns } from "./FeaturedAccessComponent.vue?vue&type=template&id=38bbb585"
import script from "./FeaturedAccessComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedAccessComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports